<template>
  <div class="scroll view" infinite-wrapper>
    <div id="confirmed">
      <owal-panel :title="`${this.isSinglePerson ? '' : 'All '}Confirmed Faces${this.isSinglePerson ? ' for ' + name : ''}`" infinite-wrapper>
        <div style="display: flex; flex-direction: row; justify-content: space-around; margin-bottom: 1rem;">
          <div style="display: flex; flex-direction: row;  align-items: center;" v-if="canPerformOperationForCurrentService('lock_training_data')">
            Show Wrong Person
            <owal-button-toggle
              style="margin-left: 1rem;"
              :segments="[{title: 'on'}, {title: 'off'}]"
              @change="toggleWrongPerson"
              :defaultIndex="1"
              />
          </div>
        </div>
        <div v-if="facesConfirmedFiltered && facesConfirmedFiltered.length" class="confirmed-list">
          <div
            v-for="confirmed of facesConfirmed"
            :key="confirmed.detection_id"
            :class="pairClass"
            >
            <!-- Original Card -->
            <div v-if="!isSinglePerson">
              <profile-view
                v-if="!isSinglePerson"
                class="original"
                :button-text="confirmed.person_name"
                :image="associatedImageURL(confirmed.frontend_face_uuid)"
                :show-chevron="true"
                button-type="text"
                @click="openProfile(confirmed.frontend_face_uuid)"
                />
            </div>
            <detection
              :profile="confirmed"
              :associatedImageURL="associatedImageURL(confirmed)"
              :baseImageURL="confirmedImageURL(confirmed.detection_id)"
              :imageTitle="imageTitle(confirmed)"
              @click="removeConfirm(confirmed.frontend_face_uuid, confirmed.detection_id, confirmed.frontend_face_uuid)"
              :showRemove="!showWrongPerson"
              :associatedImageStyle="associatedImageStyle(confirmed.evaluatorData)"
              />
          </div> <!-- Pair -->
        </div>
        <div v-if="facesConfirmed && !facesConfirmed.length">
          No results.
        </div>
      </owal-panel>
      <infinite-loading
        ref="infiniteLoading"
        force-use-infinite-wrapper="true"
        @infinite="getMoreResults"
        >
        <owal-spinner-banner slot="spinner"/>
      </infinite-loading>
    </div>
  </div>
</template>

<script>

import InfiniteLoading from 'vue-infinite-loading'
import OwalSpinnerBanner from '@/libraries/owal-ui/spinners/OwalSpinnerBanner'
import { facesconfirmed, facematchconfirm, imageForDetectionID, urlForFrontendFaceId } from '@/libraries/api/faces'
import { SVC_A } from '@/libraries/api/base'
import Detection from '@/components/shared/BaseDetection'
import ProfileView from '../faces/ProfileView'
import { isValidUUID } from '@/libraries/util/uuid'
// import  from '@/libraries/owal-ui/panels/OwalPanel'
import { OwalButtonToggle, OwalPanel } from '@/libraries/owal-ui'
import { mapGetters } from 'vuex'
import moment from 'moment'
// import ConfirmedTags from '@/shared/ConfirmedTags'

const batchSize = 50

export default {
  name: 'FacesConfirmed',
  components: {
    InfiniteLoading,
    ProfileView,
    OwalPanel,
    OwalSpinnerBanner,
    Detection,
    OwalButtonToggle,
  },
  props: {
    faceId: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      facesConfirmed: [],
      seenIds: [],
      BASE_URL: SVC_A.getBaseUri(),
      highestIndex: 0,
      showWrongPerson: false,
    }
  },
  watch: {
    'faceId' () {
      this.getMoreResults()
    },
  },
  computed: {
    ...mapGetters({
      currentDomainUUID: 'currentDomainUUID',
      currentModel: 'trainingTool/currentModel',
      canPerformOperationForCurrentService: 'entitlements/canPerformOperationForCurrentService',
    }),
    isSinglePerson () {
      const isSinglePerson = !!this.faceId && isValidUUID(this.faceId)
      return isSinglePerson
    },
    pairClass () {
      return this.isSinglePerson ? 'pair' : 'highlighted pair'
    },
    name () {
      if (!this.isSinglePerson) {
        return 'Everyone'
      } else {
        if (this.facesConfirmedFiltered && this.facesConfirmedFiltered.length) {
          return this.facesConfirmedFiltered[0].person_name
        }
        return 'Someone'
      }
    },
    facesConfirmedFiltered () {
      if (this.isSinglePerson) {
        const filtered = this.facesConfirmed.filter(x => x.frontend_face_uuid === this.faceId)
        const sorted = filtered.sort((matchA, matchB) => {
          if (matchA.evaluatorData && matchB.evaluatorData) {
            return matchA.evaluatorData.true_prob - matchB.evaluatorData.true_prob
          } else if (!matchA.evaluatorData) {
            return 1
          } else if (!matchB.evaluatorData) {
            return -1
          } else return 0
        })
        return sorted
      } else {
        return this.facesConfirmed
      }
    },
    loadingMessage () {
      return 'Loading Faces...'
    },
  },
  methods: {
    toggleWrongPerson () {
      this.facesConfirmed = []
      this.showWrongPerson = !this.showWrongPerson
      this.getMoreResults()
    },
    confirmedImageURL (detectionId) {
      return imageForDetectionID(detectionId)
    },
    imageTitle (match) {
      let title = `tagged by: ${match.tagged_by} on ${moment.utc(match.confirmed_at).local().format('DD-MM-YYYY HH-mm-ss')}`
      if (match.evaluatorData) {
        const evalString = `pred prob: ${match.evaluatorData.pred_prob}\n` +
        `true prob: ${match.evaluatorData.true_prob}`
        return `${title}\n` + evalString
      } else {
        return title
      }
    },
    associatedImageStyle (evaluatorData) {
      if (evaluatorData) {
        const incorrect = !evaluatorData.success || evaluatorData.pred_frontend_uuid === 1
        return incorrect ? 'border: 4px solid rgba(202, 0, 79, 0.9)' : 'border: 4px solid rgba(34, 139, 34, 0.5)'
      }
    },
    associatedImageURL (confirmed) {
      if (confirmed.evaluatorData) {
        return urlForFrontendFaceId(confirmed.evaluatorData.pred_frontend_uuid)
      } else if (typeof confirmed === 'string') {
        return urlForFrontendFaceId(confirmed)
      } else return undefined
    },
    getMoreResults ($state) {
      const limit = this.isSinglePerson ? 50000 : batchSize
      let offset = this.facesConfirmed.length

      if (this.facesConfirmed.length > 0 && this.isSinglePerson) {
        this.highestIndex = Math.min(this.facesConfirmedFiltered.length, this.highestIndex + batchSize)

        if ($state) {
          if (this.highestIndex === this.facesConfirmedFiltered.length) {
            $state.complete()
          } else {
            $state.loaded()
          }
        }
      } else {
        const modelKey = this.currentModel.key || undefined
        facesconfirmed(this.currentDomainUUID, offset, limit, this.faceId, modelKey, this.showWrongPerson).then(res => res.data).then(data => {
          if (!data.ok) {
            console.log(data.err)
            if ($state) {
              $state.complete()
            }
            return
          }
          this.facesConfirmed = this.facesConfirmed.concat(data.faces_confirmed)

          if ($state) {
            if (data.faces_confirmed.length < this.batchSize) {
              $state.complete()
            } else {
              $state.loaded()
            }
          }

          this.highestIndex = this.facesConfirmedFiltered.length
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    removeConfirm (frontendFaceUUID, detectionId, faceMatchID) {
      facematchconfirm(detectionId, frontendFaceUUID, false, this.currentDomainUUID, faceMatchID).then(res => res.data).then(function (data) {
        if (!data.ok) {
          console.log(data.err)
          return
        }
        const newFacesConfirmed = [...this.facesConfirmed]
        const oldIndx = newFacesConfirmed.findIndex(x => x.detection_id === detectionId)
        console.log(oldIndx)
        newFacesConfirmed.splice(oldIndx, 1)
        this.facesConfirmed = newFacesConfirmed
      }.bind(this)).catch(err => {
        console.log(err)
      })
    },
    openProfile (uuid) {
      this.$router.push('/faces/' + uuid)
    },
  },
}
</script>

<style scoped>

.scroll.view {
  height: 100%;
  width: 100%;
  overflow: auto;
}

@media only screen and (min-width: 768px) {
  .scroll.view {
    padding: 4rem;
    margin-bottom: 4rem;
  }

  .confirmed-list {
    justify-content: space-between;
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .confirmed-list {
    justify-content: center;
  }
}

#confirmed {
  height: 100%;
}

#header {
  display: flex;
  flex-direction: column;
  align-content: center;
}

#header #back {
  align-self: flex-start;
}

#header #title {
  margin: 0;
  font-weight: bold;
}

.confirmed-list {
  display: flex;
  flex-wrap: wrap;
}

.pair {
  border-radius: 10px;
  height: 130px;
  margin: 50px 10px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.highlighted.pair {
  background: #f5f5f5;
}

.pair .original {
  z-index: 1;
}

.pair .detection {
  transform: scale(0.9, 0.9);
  z-index: 2;
}

</style>
